// extracted by mini-css-extract-plugin
export default {"cofToggle":"ClientForm_cofToggle__TWTh5","cofToggleActive":"ClientForm_cofToggleActive__af3o3"};